<template>
  <md-button
    class="md-fab md-rised btn-type"
    :class="$store.state.plot.plot[plotType] === $store.state[plotType][type].id ? $store.state[plotType][type].label : ''"
    @click="setType($store.state[plotType][type].id)">
    <md-icon class="md-size-2x">
      <img
        v-if="$store.state.plot.plot[plotType] === $store.state[plotType][type].id"
        :src="$store.state.icons[plotType][type].default[$i18n.locale]"
        :alt="$store.state[plotType][type].label">
      <img
        v-else
        :src="$store.state.icons[plotType][type].grey[$i18n.locale]"
        :alt="$store.state[plotType][type].label">
    </md-icon>
  </md-button>
</template>

<script>
export default {
  name: 'TypeButton',
  props: ['plotType', 'type'],
  methods: {
    setType: function (id) {
      this.$emit('setType', id)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

</style>
